import { Category } from './Category'
import { withCategory } from './withCategory'

const ConnectedCategory = withCategory(Category)

export { ConnectedCategory as Category }
